import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=1ea9b55b&scoped=true"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"
import style0 from "./Burger.vue?vue&type=style&index=0&id=1ea9b55b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea9b55b",
  null
  
)

export default component.exports